import { Component } from '@angular/core';
import { Platform, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/login/login';
import { UserProvider } from '../providers/user/user';
import { HomePage } from '../pages/home/home';
import { ScreenOrientation } from '@ionic-native/screen-orientation';


export var isBrowser;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public events: Events,
    public userProvider: UserProvider,
    public screenOrientation: ScreenOrientation
  ) {
    this.initializeApp();

    if (this.isLogged()) {
      this.rootPage = HomePage;
    } else {
      this.rootPage = LoginPage;
    }
  }

  ionViewDidLoad() {
    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT)
  }
  
  initializeApp() {
    this.statusBar.hide();

    this.platform.ready().then((readySource) => {
      this.statusBar.show();

      this.splashScreen.hide();
    });
  }

  isLogged() {
    return this.userProvider.hasUserLogged()
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts